import http from "@/api";

/**
 * 心靈捕手 - 確認
 */
export const getMindcatcher = (params) => {
    return http.post(`/api/mindcatcher`, params);
};
